// UTF-8 safe base64url encode/decode for the share-URL round trip.
// JSON.stringify can produce multibyte chars; atob/btoa work on code units.

const toBase64Url = (bytes) => {
  let bin = ''
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i])
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

const fromBase64Url = (s) => {
  const b64 = s.replace(/-/g, '+').replace(/_/g, '/')
  const bin = atob(b64)
  const bytes = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i)
  return bytes
}

export function encodeTrip(trip) {
  if (trip === undefined || trip === null) {
    throw new Error('encodeTrip: trip is required')
  }
  const json = JSON.stringify(trip)
  return toBase64Url(new TextEncoder().encode(json))
}

export function decodeTrip(encoded) {
  if (typeof encoded !== 'string' || encoded.length === 0) {
    throw new Error('decodeTrip: encoded string is required')
  }
  const json = new TextDecoder().decode(fromBase64Url(encoded))
  return JSON.parse(json)
}
